import React, { useState } from 'react';
import Sidebar from '../Sidebar/Sidebar';
import AccessControl from '../AccessControl/AccessControl';
import Settings from '../Settings/Settings';
import Workers from '../Workers/Workers';
import Users from '../Users/Users';
import VideoTasks from '../VideoTasks/VideoTasks';
import DemoVideos from '../DemoVideos/DemoVideos';
import ApiKeys from '../ApiKeys/ApiKeys';
import Maintenance from '../Maintenance/Maintenance';
import Telemetry from '../Telemetry/Telemetry';
import Organizations from '../Organizations/Organizations';
import './Dashboard.css';

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState('access-control');

  const renderContent = () => {
    switch (activeTab) {
      case 'access-control':
        return <AccessControl />;
      case 'settings':
        return <Settings />;
      case 'workers':
        return <Workers />;
      case 'users':
        return <Users />;
      case 'video-tasks':
        return <VideoTasks />;
      case 'demo-videos':
        return <DemoVideos />;
      case 'api-keys':
        return <ApiKeys />;
      case 'maintenance':
        return <Maintenance />;
      case 'telemetry':
        return <Telemetry />;
      case 'organizations':
        return <Organizations />;
      default:
        return <Settings />;
    }
  };

  return (
    <div className="dashboard">
      <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
      <main className="dashboard-content">
        {renderContent()}
      </main>
    </div>
  );
};

export default Dashboard;
